import { JSX } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import logger from '../utils/logger';

interface ProtectedRouteProps {
  children: JSX.Element;
  roles?: string[];
  module?: string;
  action?: string;
}

export default function ProtectedRoute({
  children,
  roles,
  module,
  action = 'read',
}: ProtectedRouteProps) {
  const { token, role, hasPermission, permissions } = useAuth();
  const location = useLocation();

  if (!token) {
    logger.debug('ProtectedRoute: No token, redirecting to signin');
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }
  if (roles && role) {
    const roleLower = role.toLowerCase();
    const rolesLower = roles.map((r) => r.toLowerCase());
    if (!rolesLower.includes(roleLower)) {
      logger.debug('ProtectedRoute: Role check failed', { role, requiredRoles: roles });
      return <Navigate to="/unauthorized" replace />;
    }
  }

  if (module && !hasPermission(module, action)) {
    logger.warn('ProtectedRoute: Permission check FAILED — redirecting to /unauthorized', {
      module,
      action,
      role,
      userPermissions: permissions,
    });
    return <Navigate to="/unauthorized" replace />;
  }

  if (module) {
    logger.debug('ProtectedRoute: Permission check PASSED', { module, action, role });
  }

  return <>{children}</>;
}
